import { useState } from 'react';
import { Ui } from '@silvertours/front-shared';
import {
  Anchor,
  GradientBackground,
  StyledImage,
  StyledImageWithFocalPoint,
  Subtitle,
} from '../LinkGrid.styles';
import { GridImageLinkProps } from '../../types';
import { getGridImageSizes } from './getGridImageSizes';

export const GridImageLink = ({
  content: { href, image, label },
  rules: { color, layout, hidden },
}: GridImageLinkProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const aspectRatio =
    image?.width && image.height
      ? Number(image.width) / Number(image.height)
      : undefined;
  const sizes = getGridImageSizes(layout, aspectRatio);
  return (
    <Anchor
      bgColor={color}
      layout={layout}
      href={href}
      hidden={!!hidden}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {image?.src && image.focalPoint && (
        <StyledImageWithFocalPoint {...image} sizes={sizes} />
      )}
      {image?.src && !image.focalPoint && (
        <StyledImage
          {...image}
          fill
          sizes={sizes}
          width={undefined}
          height={undefined}
          unoptimized={Ui.needsUnoptimizedImage(image.src)}
        />
      )}
      <GradientBackground isHovered={isHovered}>
        <Subtitle as="h3" textColor="white">
          {label}
        </Subtitle>
      </GradientBackground>
    </Anchor>
  );
};
